import React from 'react';
import {connect} from 'react-redux';
import {
    closePaymentPopup,
    moneyGivenAdd,
    moneyGivenConnetToEnd,
    paymentChangeRadio,
    discountChangeRadio,
    resetPaymentMoney,
    clearDiscount,
    setPaymentItemsWithZeroDiscount
} from '../../common/paymentPopup/actions';
import {selectCashbox, resetSelectedCashboxToDefault} from '../../common/cashboxes/actions';
import AbstractPaymentPopup from './AbstractPaymentPopup';
import {countTotalItemsPrice} from '../../common/lib/util';

class PaymentPopup extends AbstractPaymentPopup {

    static propTypes = {
        msg: React.PropTypes.object,
        totalPriceVat: React.PropTypes.number.isRequired,
        selectedProducts: React.PropTypes.object.isRequired,
        homepage: React.PropTypes.object.isRequired,
        itemsDivideTo: React.PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
    }

    checkAndDoOrder() {
        const {homepage, itemsDivideTo} = this.props;
        const isTable = !!itemsDivideTo && itemsDivideTo.size > 0;
        homepage.doOrder(false, isTable, true);
    }

    getTotalPricePreRound() {
        const {totalPriceVat, itemsDivideTo} = this.props;
        if (itemsDivideTo.size > 0) {
            return countTotalItemsPrice(itemsDivideTo);
        } else {
            return totalPriceVat;
        }
    }

    getItemsToPrint() {
        const {selectedProducts, itemsDivideTo} = this.props;
        if (!!itemsDivideTo && itemsDivideTo.size > 0) {
            return itemsDivideTo;
        } else {
            return selectedProducts;
        }
    }

}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    cashboxes: state.cashboxes.get('cashboxes'),
    selectedCashbox: state.cashboxes.get('selectedCashbox'),
    defaultCashbox: state.cashboxes.get('defaultCashbox'),
    payingInProgress: state.categories.get('payingInProgress'),
    onlineState: state.categories.get('onlineState'),
    discount: state.paymentPopup.get('discount'),
    discountCurrency: state.paymentPopup.get('discountCurrency'),
    discountRadio: state.paymentPopup.get('discountRadio'),
    paymentRadio: state.paymentPopup.get('paymentRadio'),
    paymentRadioTypes: state.paymentPopup.get('paymentRadioTypes'),
    moneyGiven: state.paymentPopup.get('moneyGiven'),
    selectedItemId: state.paymentPopup.get('selectedItemId'),
    items: state.paymentPopup.get('items'),
    discountPrice: state.paymentPopup.get('discountPrice')
}), {
    closePaymentPopup, moneyGivenAdd, moneyGivenConnetToEnd, resetSelectedCashboxToDefault,
    selectCashbox, paymentChangeRadio, resetPaymentMoney, clearDiscount, setPaymentItemsWithZeroDiscount,
    discountChangeRadio
})(PaymentPopup)



// WEBPACK FOOTER //
// ./src/browser/paymentPopup/PaymentPopup.js